import { useTranslation } from 'react-i18next'
import React, { Fragment, useState } from 'react'

import { useServiceOrdersActionsList } from '../../../../utils/actions/serviceOrders/list'
import Link from '../../../../components/actions/Link'
import ModalMenu from '../../../../components/navigation/ModalMenu'
import ServiceOrderCard from '../../../../containers/serviceOrders/ServiceOrderCard'

const ServiceOrdersListItem = ({ item }) => {
  const { t } = useTranslation()
  const [actionsOpen, setActionsOpen] = useState(false)
  const options = useServiceOrdersActionsList(item)

  return (
    <Fragment>
      <Link block onClick={() => setActionsOpen(true)}>
        <ServiceOrderCard item={item} />
      </Link>
      <ModalMenu t={t} open={actionsOpen} onClose={() => setActionsOpen(false)} options={options} />
    </Fragment>
  )
}

export default ServiceOrdersListItem
